import * as React from "react";
import { NGProviderBrowser, formatSizeForProviderBrowser } from "../../../ngProviderBrowser";
import { homeLink, request } from "../../../../../services/cpln";
import { Mk8sInput } from "../../../../../schema/types/mk8s/input/mk8s";
import { Divider } from "antd";
import { v4 as uuidv4 } from "uuid";
import { inputToMk8s } from "../../../draft/utils/inputToMk8s";
import { formSetValue, formTriggerValidation, useCpFormValue } from "../../../../gvc/testNewForm/utils";
import { CpSelect } from "../../../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../../../gvc/testNewForm/CpInput";
import { CpArrayString } from "../../../../gvc/testNewForm/CpArrayString";
import { CpArrayObject } from "../../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../../../../workload/draft/CpArrayItemNameValuePair";
import { store } from "../../../../../store";

import { useCpFormContext } from "../../../../../components/form/useCpFormContext";

interface Props {}
export const TritonLoadBalancer: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const [browserKey, setBrowserKey] = React.useState("");

  const type = useCpFormValue(`triton.loadBalancer.type`);
  const publicNetworkId = useCpFormValue(`triton.loadBalancer.manual.publicNetworkId`);
  const privateNetworkIds = useCpFormValue(`triton.loadBalancer.manual.privateNetworkIds`);
  const imageId = useCpFormValue(`triton.loadBalancer.manual.imageId`);
  const packageId = useCpFormValue(`triton.loadBalancer.manual.packageId`);

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Load Balancer
      </Divider>
      <CpFormItem>
        <CpLabel name={`triton.loadBalancer.type`}>URL</CpLabel>
        <CpSelect
          name={`triton.loadBalancer.type`}
          options={[
            { label: "None", value: "none" },
            { label: "Gateway", value: "gateway" },
            { label: "Manual", value: "manual" },
          ]}
          style={{ width: 450 }}
        />
        <CpErrorWarning name={`triton.loadBalancer.type`} />
      </CpFormItem>
      {type === "manual" ? (
        <>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.packageId`}>Package ID</CpLabel>
            <CpInput
              name={`triton.loadBalancer.manual.packageId`}
              style={{ width: 450 }}
              // buttons={[
              //   {
              //     icon: <MoreHorizontal />,
              //     onClick: () => setBrowserKey("packages"),
              //     tooltip: "Browse",
              //   },
              // ]}
            />
            <CpErrorWarning name={`triton.loadBalancer.manual.packageId`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.imageId`}>Image ID</CpLabel>
            <CpInput
              name={`triton.loadBalancer.manual.imageId`}
              style={{ width: 450 }}
              // buttons={[
              //   {
              //     icon: <MoreHorizontal />,
              //     onClick: () => setBrowserKey("lb_images"),
              //     tooltip: "Browse",
              //   },
              // ]}
            />
            <CpErrorWarning name={`triton.loadBalancer.manual.imageId`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.publicNetworkId`}>Public Network ID</CpLabel>
            <CpInput
              name={`triton.loadBalancer.manual.publicNetworkId`}
              style={{ width: 450 }}
              // buttons={[
              //   {
              //     icon: <MoreHorizontal />,
              //     onClick: () => setBrowserKey("public-networks"),
              //     tooltip: "Browse",
              //   },
              // ]}
            />
            <CpErrorWarning name={`triton.loadBalancer.manual.publicNetworkId`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.count`}>Count</CpLabel>
            <CpInput name={`triton.loadBalancer.manual.count`} style={{ width: 450 }} />
            <CpErrorWarning name={`triton.loadBalancer.manual.count`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.cnsInternalDomain`}>CNS Internal Domain</CpLabel>
            <CpInput name={`triton.loadBalancer.manual.cnsInternalDomain`} style={{ width: 450 }} />
            <CpErrorWarning name={`triton.loadBalancer.manual.cnsInternalDomain`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.cnsPublicDomain`}>CNS Public Domain</CpLabel>
            <CpInput name={`triton.loadBalancer.manual.cnsPublicDomain`} style={{ width: 450 }} />
            <CpErrorWarning name={`triton.loadBalancer.manual.cnsPublicDomain`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.logging.nodePort`}>Logging | Node Port</CpLabel>
            <CpInput name={`triton.loadBalancer.manual.logging.nodePort`} style={{ width: 450 }} />
            <CpErrorWarning name={`triton.loadBalancer.manual.logging.nodePort`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`triton.loadBalancer.manual.logging.externalSyslog`}>Logging | External Syslog</CpLabel>
            <CpDescription>E.g. sub.host:1, host:65535</CpDescription>
            <CpInput name={`triton.loadBalancer.manual.logging.externalSyslog`} style={{ width: 450 }} />
            <CpErrorWarning name={`triton.loadBalancer.manual.logging.externalSyslog`} />
          </CpFormItem>
          <CpArrayString label={`Private Network IDs`} name={`triton.loadBalancer.manual.privateNetworkIds`} />
          <CpArrayObject
            label={`Metadata`}
            name={`triton.loadBalancer.manual.metadata`}
            labels={["Key", "Value"]}
            factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
          >
            <CpArrayItemNameValuePair />
          </CpArrayObject>
          <CpArrayObject
            label={`Tags`}
            name={`triton.loadBalancer.manual.tags`}
            labels={["Key", "Value"]}
            factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
          >
            <CpArrayItemNameValuePair />
          </CpArrayObject>
        </>
      ) : null}
      {browserKey === "public-networks" ? (
        <NGProviderBrowser
          title="Browse Triton Public Networks"
          initialValue={publicNetworkId}
          fetchData={async () => {
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "public-networks",
                cluster: inputToMk8s(values),
              },
            });
            return data;
          }}
          onOk={(value) => {
            formSetValue(id, `triton.loadBalancer.manual.publicNetworkId`, value as string);
            formTriggerValidation(id);
          }}
          onClose={() => setBrowserKey("")}
          sortable
          labels={["Name", "Id", "Description", "Subnet", "VLAN Id"]}
          getData={(item: any) => [item.id, item.name, item.id, item.description, item.subnet, item.vlan_id]}
        />
      ) : null}
      {browserKey === "private-networks" ? (
        <NGProviderBrowser
          title="Browse Triton Private Networks"
          initialValue={privateNetworkIds.map((i) => i.value)}
          fetchData={async () => {
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "private-networks",
                cluster: inputToMk8s(values),
              },
            });
            return data;
          }}
          onOk={(_value) => {
            const values: string[] = _value as any;
            const form = store.getState().form.instances[id];
            const formValues: Mk8sInput = form.values as any;
            const existing = formValues.triton.loadBalancer.manual.privateNetworkIds;

            const newItems = values.map((value) => {
              const found = existing.find((i) => i.value === value);
              return found || { id: uuidv4(), value };
            });
            formSetValue(id, `triton.loadBalancer.manual.privateNetworkIds`, newItems);
            formTriggerValidation(id);
          }}
          onClose={() => setBrowserKey("")}
          sortable
          multipleChoice
          labels={["Name", "Id", "Description", "Subnet", "VLAN Id"]}
          getData={(item: any) => [item.id, item.name, item.id, item.description, item.subnet, item.vlan_id]}
        />
      ) : null}
      {browserKey === "lb_images" ? (
        <NGProviderBrowser
          title="Browse Triton Images"
          initialValue={imageId}
          fetchData={async () => {
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "lb_images",
                cluster: inputToMk8s(values),
              },
            });
            return data;
          }}
          onOk={(value) => {
            formSetValue(id, `triton.loadBalancer.manual.imageId`, value as string);
            formTriggerValidation(id);
          }}
          onClose={() => setBrowserKey("")}
          sortable
          distinctFilters={["Type", "Brand"]}
          filteredColumns={["Name"]}
          labels={["Name", "Id", "Size", "Type", "Brand", "Version"]}
          getData={(item: any) => [
            item.id,
            item.name,
            item.id,
            [item.image_size || 0, item.image_size ? `${item.image_size / 1024}Gi` : "-"],
            item.type,
            item.requirements?.brand,
            item.version,
          ]}
        />
      ) : null}
      {browserKey === "packages" ? (
        <NGProviderBrowser
          title="Browse Triton Packages"
          initialValue={packageId}
          fetchData={async () => {
            // TODOMK8S paginate
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "packages",
                cluster: inputToMk8s(values),
              },
            });
            return data;
          }}
          onOk={(value) => {
            formSetValue(id, `triton.loadBalancer.manual.packageId`, value as string);
            formTriggerValidation(id);
          }}
          onClose={() => setBrowserKey("")}
          sortable
          labels={["Name", "Id", "Brand", "Version", "Cores", "Memory", "Disk", "Description"]}
          distinctFilters={["Brand", "Cores", "Memory", "Disk"]}
          getData={(item: any) => {
            return [
              //
              item.id,
              item.name,
              item.id,
              item.brand,
              item.version,
              item.vcpus,
              [item.memory, formatSizeForProviderBrowser(item.memory, "MB")],
              [item.disk, formatSizeForProviderBrowser(item.disk, "MB")],
              item.description,
            ];
          }}
        />
      ) : null}
    </>
  );
};
